import React, { FC } from "react";
import classNames from "classnames";

import { CURRENCY_MAP } from "../../../../constants";
import { Currency } from "../../../../types/InvoiceTypes";

type Props = {
  currency: Currency;
  onClick?: (currency: Currency) => void;
  className?: string;
  dataTest?: string;
};

export const CurrencyOption: FC<Props> = ({
  currency,
  onClick,
  className,
  dataTest,
}) => {
  const { icon, symbol, code } = CURRENCY_MAP[currency];

  return (
    <div
      className={classNames("flex gap-2 items-center", className, {
        "cursor-pointer": !!onClick,
      })}
      data-test={dataTest}
      onClick={() => onClick && onClick(currency)}
    >
      <img
        src={icon}
        alt={`${symbol.toUpperCase()}`}
        className="w-6 h-6 rounded-full object-cover object-center"
      />

      {code}
    </div>
  );
};
